<template>
	<div class="external-links">
		<a
			class="external-link"
			:class="{ 'no-color': !link.color, disabled: link.isDisabled }"
			:style="{ '--link-color': `${link.color}e0` }"
			:href="link.url"
			v-for="link in externalLinks"
			:key="link.url"
			:alt="link.site"
			target="_blank"
			rel="noopener noreferrer"
		>
			<span class="visually-hidden">{{ link.site }}</span>
			<div class="icon-wrap" :style="{ background: link.color }">
				<img :src="link.icon" class="icon" v-if="link.icon" />
				<icon
					class="icon"
					:name="link.site === 'Official Site' ? 'compass' : 'link'"
					width="14"
					color="#fff"
					:fill="link.site !== 'Official Site'"
					v-else
				/>
			</div>
		</a>
	</div>
</template>

<script>
export default {
	props: {
		media: {
			type: Object,
			required: true
		}
	},
	computed: {
		externalLinks() {
			const links = this.media.externalLinks;

			if (links.length > 4) {
				return links
					.filter(link => link.site !== "Official Site" && link.site !== "Twitter")
					.slice(0, 4);
			}

			return links;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.external-links {
	display: flex;
	gap: 6px;

	.external-link {
		align-content: center;
		background: #515381;
		border-radius: 3px;
		display: inline-flex;
		height: 23px;
		justify-content: center;
		width: 23px;

		&.disabled {
			opacity: 0.8;
			pointer-events: none;

			.icon-wrap {
				opacity: 0.8;
			}
		}
		.icon-wrap {
			align-items: center;
			background: color(blue-800);
			border-radius: 3px;
			display: flex;
			height: 24px;
			justify-content: center;
			min-width: 0;
			outline: none;
			padding: 4px;
			width: 100%;
		}

		.icon {
			opacity: 0.98;
			min-width: 0;
			outline: none;
			width: 100%;
			color: color(white);
		}
	}
}
</style>
